export var AdditionalAmountType;
(function (AdditionalAmountType) {
    AdditionalAmountType["TIP"] = "TIP";
    AdditionalAmountType["CONVENIENCE_FEE"] = "CONVENIENCE_FEE";
    AdditionalAmountType["SUB_TOTAL"] = "SUB_TOTAL";
})(AdditionalAmountType || (AdditionalAmountType = {}));
//# sourceMappingURL=AdditionalAmountType.js.map